import * as React from 'react'
import { Box } from '@mui/material'
import Night from '@/assets/chart_icons/Night.svg'
import Day from '@/assets/chart_icons/Day.svg'
import DayNight from '@/assets/chart_icons/DayNight.svg'

type Props = {
  value?: number
  onChange?: (id: number) => void
  isDarkMode?: boolean
}

const modes = [
  { id: 1, name: 'Day', icon: Day, width: 20, height: 20 },
  { id: 2, name: 'Night', icon: Night, width: 18, height: 18 },
  { id: 3, name: 'DayNight', icon: DayNight, width: 23, height: 23 },
]

export default function HeaderTheChart({
  value,
  onChange,
  isDarkMode = false,
}: Props) {
  const [modeId, setModeId] = React.useState<number>(value ?? 1)

  React.useEffect(() => {
    if (typeof value === 'number') setModeId(value)
  }, [value])

  const handleClick = (id: number) => {
    setModeId(id)
    onChange?.(id)
  }

  // Theme-aware colors
  const activeBg = isDarkMode ? '#3B82F6' : '#72A4EB'
  const inactiveBg = isDarkMode ? '#374151' : '#E3F5FF'

  return (
    <Box sx={{ display: 'flex', gap: '8px' }}>
      {modes.map(mode => (
        <Box
          key={mode.id}
          onClick={() => handleClick(mode.id)}
          sx={{
            bgcolor: mode.id === modeId ? activeBg : inactiveBg,
            borderRadius: '5px',
            cursor: 'pointer',
            width: 25,
            height: 25,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'transform 120ms ease, background-color 0.3s ease',
            '&:hover': { transform: 'translateY(-1px)' },
            '&:active': { transform: 'translateY(0)' },
          }}
        >
          <img
            src={mode.icon}
            alt={mode.name}
            width={mode.width}
            height={mode.height}
            style={{
              filter: mode.id === modeId || isDarkMode ? 'brightness(0) invert(1)' : 'none',
              display: 'block',
            }}
          />
        </Box>
      ))}
    </Box>
  )
}
